export default __webpack_public_path__ + "static/serhii-saviuk-04fa0034f14eda36e1ef786600a2249f.jpg";